define(function () {
    'use strict';

    var testUrlParameters;

    function getAllUrlParameters() {
        if (testUrlParameters) {
            return testUrlParameters;
        }
        return window.location.search.substring(1);
    }

    function getUrlPath() {
        return window.location.pathname;
    }

    function redirectToUrl(destinationUrl) {
        window.location.replace(destinationUrl);
    }

    function navigateToUrl(destinationUrl) {
        window.location.href = destinationUrl;
    }

    return {
        getUrlParameter: function (paramName) {
            var params = getAllUrlParameters();
            console.log(params);
            var paramList = params.split('&');

            for (var i = 0; i < paramList.length; i++) {
                var param = paramList[i].split('=');
                if (param[0] === paramName) {
                    return param[1];
                }
            }
        },
        getAllUrlParameters: getAllUrlParameters,
        setTestUrlParameters: function (urlParameters) {
            testUrlParameters = urlParameters;
        },
        redirectToUrl: redirectToUrl,
        navigateToUrl: navigateToUrl,
        getUrlPath: getUrlPath
    };
});



//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/utils/urls.js
// module id = g+w9
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16